import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { swalSubmit } from "../../shared/swalSubmit";
import axiosConfig from "../../axiosConfig";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as headers from "../../shared/language.json";
import * as regEx from "../../shared/regularExpressions";
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import AutoComplete from "@material-ui/lab/Autocomplete";
import Edit from "@material-ui/icons/Edit";
import Loading from "../Loading/loading";
import Chip from "@material-ui/core/Chip";

import "../Forms/Forms.css";

const useStyles = makeStyles(styles);

function Device(props) {
  const history = useHistory();
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [device, setDevice] = useState({});
  const [loading, setLoading] = useState(true);
  const [isEditable, setisEditable] = useState(props.location.selected ? true : false)
  const classes = useStyles();

  const editDevice = () => {
    setisEditable(!isEditable);
  }

  useEffect(() => {
    if (props.location.selected !== undefined) {

      const selectedDevice = axiosConfig.get(`/Device/GetDevice/${props.location.selected}`);
      const deviceTypes = axiosConfig.get("/Device/GetAllDeviceTypes");
      axios
        .all([selectedDevice, deviceTypes])
        .then(
          axios.spread((...res) => {
            setDevice(res[0].data);
            formik.setValues(res[0].data);
            setDeviceTypes(res[1].data);
            setLoading(false);
          })
        )
        .catch((err) => {
          console.log(err);
        });
    } else { axiosConfig.get("/Device/GetAllDeviceTypes").then((res) => { setDeviceTypes(res.data); setLoading(false) }) }
  }, []);


  const changeStatus = () => {
    if (device.beneficiaryId) {
      Swal.fire(`Δεν μπορείτε να αναφέρετε την Συσκευή με IMEI ${device.id} ως μη λειτουργική διότι είναι Δεσμευμένη στον Ωφελούμενο με κωδικό ${device.beneficiaryId}`,"", "warning")
    } else {
      Swal.fire({
        input: 'textarea',
        inputLabel: 'Message',
        confirmButtonText: "ΟΚ",
        cancelButtonText: "Άκυρο",
        inputPlaceholder: 'Συμπληρώστε Σχόλια με τουλάχιστον 5 χαρακτήρες',
        inputAttributes: {
          'aria-label': 'Συμπληρώστε Σχόλια με τουλάχιστον 5 χαρακτήρες'
        },
        showCancelButton: true
      }).then((text) => {
        if (text.value && text.value.length > 5) {
          Swal.fire({
            title: "",
            text: `Έχετε επιλέξει να αναφέρεται την Συσκευή με το IMEI ${device.imei} Ως μη Λειτουργική.Η διαδικασία αυτή δεν μπορεί να ανακληθεί.Είστε βέβαιοι;`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ναι",
            cancelButtonText: "Οχι",
            showLoaderOnConfirm: true,
            closeOnClickOutside: false,
            preConfirm: () => {
              Swal.fire({
                title: "",
                text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Ναι",
                cancelButtonText: "Οχι",
              }).then((result) => {
                if (result.isConfirmed) {
                  axiosConfig.put(`/Device/DeactivateDevice/${device.id}`, { deActivate: text.value }).then((res) => {
                    if (res.status === 200) {
                      setDevice({ ...device, isActive: false, deActivate: text.value })
                    }
                  })
                }
              })
            }
          })
        }
      })
    }
  };



  const formik = useFormik({
    initialValues: {
      imei: "",
      imsi: "",
      msisdn: "",
      serialNumber: "",
      deviceTypeId: "",
    },
    validationSchema: Yup.object({
      imei: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS)
        .max(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS),
      imsi: Yup.string()
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS)
        .max(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS),
      msisdn: Yup.string()
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS)
        .max(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS),
      serialNumber: Yup.string()
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS)
        .max(15, headers.FORMIKERRORMESSAGES.FIFTEENCHARACTERS),
      deviceTypeId: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
    }),
    onSubmit: (values) => {
      Swal.fire({
        title: "",
        text: props.location.selected === undefined ? "Έχετε επιλέξει να εισάγεται μια νέα συσκευή στο σύστημα, η οποία θα πρέπει να πληρεί τις προδιαγραφές του συστήματος. Είστε βέβαιοι;" : `Έχετε επιλέξει να πραγματοποιήσετε αλλαγή στη συσκευή με ΙΜΕΙ ${values.imei}.Τα στοιχεία της συσκευής είναι σημαντικά για την ορθή λήψη σημάτων και ειδοποιήσεων. Είστε βέβαιοι ;`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
        showLoaderOnConfirm: true,
        closeOnClickOutside: false,
        preConfirm: () => {
          Swal.fire(swalSubmit).then((result) => {
            if (result.isConfirmed) {
              if (props.location.selected === undefined) {
                return axiosConfig
                  .post(`/Device/CreateDevice`, values)
                  .then((response) => {
                    if (response.status === 200) {
                      history.push("/all-devices");
                    }
                  })
              } else {
                return axiosConfig
                  .put(`/Device/UpdateDevice`, values)
                  .then((response) => {
                    if (response.status === 200) {
                      history.push("/all-devices");
                    }
                  })
              }
            }
          })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  });

  if (loading === false) {
    return (
      <form className="Form">
        <Card>
          <CardHeader color="warning">
            <h1 className={classes.cardTitleWhite}>Συσκευή</h1>
          </CardHeader>
          <CardBody>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography component="h1" variant="h6" align="left">
                  Συσκευή
                  {props.location.selected !== undefined ?
                    < Tooltip title="Επεξεργασία">
                      <Button onClick={editDevice}>
                        <Edit />
                      </Button>
                    </Tooltip>
                    : null}
                  {(device.isActive === true && props.location.selected !== undefined) ? <Chip
                    label="Λειτουργική"
                    style={{ backgroundColor: "green", color: "white" }}
                  /> : (device.isActive === false && props.location.selected !== undefined) ? <Chip
                    label="Μη Λειτουργική"
                    style={{ backgroundColor: "red", color: "white" }}
                  /> : null}
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                required
                  disabled={isEditable}
                  id="imei"
                  name="imei"
                  label="IMEI"
                  fullWidth
                  variant="outlined"
                  {...formik.getFieldProps("imei")}
                />
                {formik.touched.imei && formik.errors.imei ? (
                  <span style={{ color: "red" }}>{formik.errors.imei}</span>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  disabled={isEditable}
                  id="imsi"
                  name="imsi"
                  label="IMSI"
                  variant="outlined"
                  fullWidth
                  {...formik.getFieldProps("imsi")}
                />
                {formik.touched.imsi && formik.errors.imsi ? (
                  <span style={{ color: "red" }}>{formik.errors.imsi}</span>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  disabled={isEditable}
                  id="msisdn"
                  name="msisdn"
                  label="MSISDN"
                  variant="outlined"
                  fullWidth
                  {...formik.getFieldProps("msisdn")}
                />
                {formik.touched.msisdn && formik.errors.msisdn ? (
                  <span style={{ color: "red" }}>{formik.errors.msisdn}</span>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  disabled={isEditable}
                  id="serialNumber"
                  name="serialNumber"
                  label="SerialNumber"
                  variant="outlined"
                  fullWidth
                  {...formik.getFieldProps("serialNumber")}
                />
                {formik.touched.serialNumber && formik.errors.serialNumber ? (
                  <span style={{ color: "red" }}>
                    {formik.errors.serialNumber}
                  </span>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={12}>
                <AutoComplete
                  disabled={isEditable}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      formik.setFieldValue("deviceTypeId", "");
                    } else {
                      formik.setFieldValue("deviceTypeId", newValue.id);
                    }
                  }}
                  value={deviceTypes.find(
                    (opt) => opt.id === formik.values.deviceTypeId
                  )}
                  options={deviceTypes}
                  getOptionLabel={(option) => "Τύπος:" + option.description}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Συσκευή . . ."
                      variant="outlined"
                    />
                  )}
                />
                {formik.touched.deviceTypeId && formik.errors.deviceTypeId ? (
                  <span style={{ color: "red" }}>{formik.errors.deviceTypeId}</span>
                ) : null}
              </Grid>
              {props.location.selected !== undefined ?
                <Grid item xs={12} style={{ marginTop: "16px" }}>
                  <Typography component="h1" variant="h6" align="left" >
                    {device.beneficiaryId ? `*Διαθεσιμότητα Συσκευής: Η συσκευή είναι Δεσμευμένη στον Ωφελούμενο με κωδικό ${device.beneficiaryId}` : "*Διαθεσιμότητα Συσκευής: Η συσκευή δεν ειναι Δεσμευμένη"}
                  </Typography>

                </Grid>
                : null}
              <Grid
                item
                sm={12}
               className = {classes.buttonDevice}
              >
                <Button
                  disabled={isEditable}
                  variant="contained"
                  color="primary"
                  onClick={formik.handleSubmit}
                >
                  Αποθηκευση
                </Button>
                <Divider className ={classes.dividerDevice}></Divider>
              </Grid>
            </Grid>
            {props.location.selected !== undefined ?
              (
                <>
                  <Grid container style={{ marginTop: "16px" }}>
                    <Grid item xs={8}>
                      <Typography component="h1" variant="h6" align="left">
                        {device.isActive === true ? `*Κατάσταση Συσκευής: Λειτουργική` : "*Κατάσταση Συσκευής: Μη Λειτουργική"}
                      </Typography>
                    </Grid>
                    {device.isActive === true ?
                      <Grid item xs={4} sm={4}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            changeStatus();
                          }}>
                          αναφορα συσκευης ως μη λειτουργικη
                        </Button>
                      </Grid> : null}
                  </Grid>
                  {device.isActive === false ?
                    <Grid item xs={12} style={{ marginTop: "30px", textAlign: "left" }}>
                      <TextField
                        label="Multiline"
                        disabled
                        multiline
                        rows={6}
                        placeholder
                        id="comments"
                        label="Σχόλια/Παρατηρήσεις Αναφοράς"
                        name="comments"
                        variant="outlined"
                        value={device.deActivate}
                      />
                    </Grid> : null}
                </>
              ) : null}
          </CardBody>
        </Card>
      </form >
    );
  } else {
    return <Loading></Loading>;
  }
}

export default Device;
